var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{staticClass:"ma-0",attrs:{"items":_vm.Items,"item-text":_vm.Nombre,"return-object":"","outlined":"","dense":"","prefix":_vm.Titulo,"hide-details":""},model:{value:(_vm.SelectedItem),callback:function ($$v) {_vm.SelectedItem=$$v},expression:"SelectedItem"}})
}
var staticRenderFns = []

export { render, staticRenderFns }